<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto; height:300px">
      <d-field label="Add to Group">
        <d-autocomplete v-model="form.groupId"
                        icon="search"
                        :data="availableGroups"
                        item-key="id"
                        placeholder="Select a group..."
                        field="name"
                        @typing="getGroupsDataAsync"
        >
          <template slot="empty">
            No results found
          </template>
        </d-autocomplete>
      </d-field>
      <div style="height:200px" />
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Add
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>

  import axios from 'axios';
  import debounce from 'lodash/debounce';

  export default {

    props: {
      userId: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      availableGroups: [],
      saving: false,
      form: {
        groupId: null,
      },
    }),

    methods: {
      async saveForm() {
        this.saving = true;

        try {
          await axios.post(`/api/admin/groups/${this.form.groupId}/users/${this.userId}`);
          this.$parent.events.getPaged();
          this.$parent.close();
          this.$toast.success('User added successfully!');
        } catch (error) {
          this.$toast.open({ message: error.response.data[0], color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },

      getGroupsDataAsync: debounce(async function (name = '') {
        try {
          const { data } = await axios.get(`/api/group-lookup?filter=${name}`);
          this.availableGroups = data.filter((x) => !x.autoGenerated);
        } catch (error) {
          this.availableGroups = [];
          throw error;
        }
      }, 500),

      async getEmphases() {
        const { data } = await axios.get('/api/admin/system-config/emphases/paged?currentPage=1&pageSize=99999&sortDir=name asc');
        this.emphases = data.resultItems;
      },
    },

  };
</script>